import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Container } from 'semantic-ui-react';

// Layout Components
import NavBar from './components/layout/NavBar';
import Footer from './components/layout/Footer';

// Page Components
import Home from './pages/Home';
import Auth from './pages/Auth';
import Calculator from './pages/Calculator';
import DeleteAccount from './pages/DeleteAccount';
import Feed from './pages/Feed';
import Forums from './pages/Forums';
import Oils from './pages/Oils';
import Posts from './pages/Posts';
import Privacy from './pages/Privacy';
import Profiles from './pages/Profiles';
import Recipes from './pages/Recipes';
import Settings from './pages/Settings';
import PageNotFound from './pages/PageNotFound';
import OilView from './pages/OilView';
import RecipePage from './pages/RecipePage';
import AdditivesPage from './pages/AdditivesPage';
import AdditiveDetailPage from './pages/AdditiveDetail';

// Admin Pages
import AdminUsers from './pages/admin/Users';
import AdminOils from './pages/admin/Oils';

// Context Providers
import { AuthProvider } from './contexts/AuthContext';

// Create a client
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <AuthProvider>
          <div id="root-app">
            <NavBar />
            
            <Container className="main-content">
              <Routes>
                <Route path="/auth" element={<Auth />} />
                <Route path="/calculator" element={<Calculator />} />
                <Route path="/delete-account" element={<DeleteAccount />} />
                <Route path="/feed" element={<Feed />} />
                <Route path="/oils" element={<Oils />} />
                <Route path="/oils/:id" element={<OilView />} />
                <Route path="/additives" element={<AdditivesPage />} />
                <Route path="/additives/:id" element={<AdditiveDetailPage />} />
                <Route path="/posts" element={<Posts />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/profiles" element={<Profiles />} />
                <Route path="/recipes" element={<Recipes />} />
                <Route path="/recipes/:id" element={<RecipePage />} />
                <Route path="/settings" element={<Settings />} />
                
                {/* Admin Routes */}
                <Route path="/admin/users" element={<AdminUsers />} />
                <Route path="/admin/oils" element={<AdminOils />} />
                
                <Route path="/" element={<Home />} />
                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </Container>

            <Footer />
          </div>
        </AuthProvider>
      </HelmetProvider>
    </QueryClientProvider>
  );
}

export default App; 